(() => {
  if (customElements.get('pxs-infinite-products')) return;
  class InfiniteProducts extends HTMLElement {
    connectedCallback() {
      if (this.observer || !('IntersectionObserver' in window)) return;
      this.grid = this.querySelector('[data-pxs-grid]');
      this.more = this.querySelector('[data-pxs-more]');
      if (!this.grid || !this.more) return;
      this.loaded = new Set();
      this.ids = new Set(Array.from(this.grid.querySelectorAll('[data-product-id]'), card => card.dataset.productId));
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.load();
      }, {rootMargin:'300px 0px'});
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.controller?.abort();
      this.busy = false;
    }
    update() {
      const link = this.more.querySelector('[data-pxs-next]');
      this.next = link?.getAttribute('href');
      const pagination = this.more.querySelector('[data-pxs-pagination]');
      if (pagination) pagination.hidden = true;
      this.observer?.unobserve(this.more);
      if (this.next) this.observer?.observe(this.more);
    }
    async load() {
      if (!this.next || this.busy || !this.isConnected) return;
      const url = new URL(this.next, location.href);
      if (url.origin !== location.origin || this.loaded.has(url.href)) return;
      const key = url.href;
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.busy = true;
      this.grid.setAttribute('aria-busy','true');
      const loading = this.more.querySelector('[data-pxs-loading]');
      if (loading) loading.hidden = false;
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('Unable to load products');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = Array.from(doc.querySelectorAll('pxs-infinite-products')).find(element => element.dataset.sectionId === this.dataset.sectionId);
        const grid = incoming?.querySelector('[data-pxs-grid]');
        const more = incoming?.querySelector('[data-pxs-more]');
        if (!grid || !more) throw new Error('Missing product section');
        if (!this.isConnected) return;
        const fragment = document.createDocumentFragment();
        grid.querySelectorAll('[data-pxs-card]').forEach(card => {
          if (this.ids.has(card.dataset.productId)) return;
          this.ids.add(card.dataset.productId);
          card.querySelectorAll('img').forEach(image => image.loading = 'lazy');
          fragment.append(card);
        });
        this.grid.append(fragment);
        this.loaded.add(key);
        this.more.replaceChildren(...more.childNodes);
        this.dispatchEvent(new CustomEvent('pxs:products:loaded', {bubbles:true}));
        this.update();
      } catch (error) {
        if (!this.isConnected) return;
        this.observer?.disconnect();
        const pagination = this.more.querySelector('[data-pxs-pagination]');
        if (pagination) pagination.hidden = false;
        const message = this.more.querySelector('[data-pxs-load-error]');
        if (message) message.hidden = false;
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.grid.removeAttribute('aria-busy');
        const status = this.more.querySelector('[data-pxs-loading]');
        if (status) status.hidden = true;
      }
    }
  }
  customElements.define('pxs-infinite-products', InfiniteProducts);
})();
